import React, { useState, useRef } from "react";
import ErrorBoundary from "lib/ErrorBoundary";
import useIsMobile from "lib/hooks/useIsMobile";
import { Col, Form } from "react-bootstrap";
import { getParam } from "lib/routing";
import { AutoSuggestions } from "../viewLayout/searchBox/AutoSuggestions";
import { MenuDropdowns } from "./MenuDropdowns";
import { MobileSearchBox } from "./parts/MobileSearchBox";
import { SearchBox } from "../viewLayout/searchBox/SearchBox";

export function MenuFilterBar({ chatOpen, panelWidth }) {
  const isMobile = useIsMobile();
  return (
    <ErrorBoundary>
      {isMobile ? <MobileSearchBox/> : <DesktopMenuFilterBar chatOpen={chatOpen} panelWidth={panelWidth}/>}
    </ErrorBoundary>
  );
}

export function DesktopMenuFilterBar({ chatOpen, panelWidth }) {
  const defaultKeyword = getParam("") || getParam("q") || getParam("title") || "";
  const [keyword, setKeyword] = useState(defaultKeyword);
  const [isAcVisible, setAcVisible] = useState();
  const [isSearching, setIsSearching] = useState();
  const [nairaMode, setNairaMode] = useState(false);
  const suppressBlurRef = useRef(false);

  const handleNairaSearch = (searchText) => {
    searchText = (searchText || keyword || "").trim();
    if (!searchText) return;
    window.dispatchEvent(
      new CustomEvent("open-naira-chat", {
        detail: {tab: 0, query: searchText},
      })
    );
    setKeyword("");
    setAcVisible(false);
  };

  return (
    <Form onSubmit={(ev) => ev.preventDefault()}>
      <Form.Row className="menuFilterBar d-flex pl-2 pt-2 mt-0">
        <MenuDropdowns/>

        <Col className="ml-auto mr-0 pl-3 search-box-col">
          <SearchBox
            keyword={keyword}
            setKeyword={setKeyword}
            setAcVisible={setAcVisible}
            isSearching={isSearching}
            setIsSearching={setIsSearching}
            className="rounded-xl-left border-primary border-2"
            size="sm"
            isDropdownVisible={false}
            autoFocus
            preventFormSubmit={nairaMode}
            onNairaEnter={nairaMode ? handleNairaSearch : undefined}
            suppressBlurRef={suppressBlurRef}
          />
        </Col>
      </Form.Row>
      {isAcVisible && (
        <AutoSuggestions
          keyword={keyword}
          setKeyword={setKeyword}
          setIsSearching={setIsSearching}
          chatOpen={chatOpen}
          panelWidth={panelWidth}
          onNairaSearch={handleNairaSearch}
          nairaMode={nairaMode}
          setNairaMode={setNairaMode}
          suppressBlurRef={suppressBlurRef}
        />
      )}
    </Form>
  );
}
